import '../App.css';
import { useEffect, useRef, useState } from 'react';
import MenuIcon from '../assets/menu.svg';
import CloseIcon from '../assets/close.svg';
import { io } from 'socket.io-client'
import OvenPlayer from 'ovenplayer'

function Splash() {

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const socketRef = useRef()
  const socketAddr = process.env.REACT_APP_SOCK
  const [place, setPlace] = useState(false)
  const [playToken, setToken] = useState(false)

  const playerRef = useRef(null)
  const containerRef = useRef(null)

  useEffect(() => {
    if (containerRef.current && !playerRef.current) {
      playerRef.current = OvenPlayer.create(containerRef.current, {
        autoStart: true,
        sources: [{
          type: 'webrtc',
          file: 'wss://teejeigh.com:3333/app/stream'  // Your WireGuard-fed stream
        }]
      });
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.remove();
        playerRef.current = null;
      }
    };
  },[])

  useEffect(() => {
    //socket
    socketRef.current = io(socketAddr)

    socketRef.current.on('connect', () => {
      console.log('connected to socket')
    })

    socketRef.current.on('message', (msg) => {
      if (msg.msg == 'place'){
        console.log(msg.pos)
        setPlace(msg.pos)
      }else if (msg.msg == 'update'){
        setPlace(msg.num)
      }else if (msg.msg == 'start'){
        setToken(msg.id)
      }
    })

    return () => socketRef.current?.disconnect()
  },[])


  function enterQueue() {
    socketRef.current.emit('message', {'msg':'enter'})
  }

  function activateTurn() {
    socketRef.current.emit('message', {'msg':'start'})
  }

  function exitSession() {
    socketRef.current.emit('message', {'msg':'end', 'hash':playToken})
    setToken(false)
    setPlace(false)
  }

  return (
      <div className='page' style={{background:'black', width:'100%'}}>
        <div style={{ width: '100%', display: 'flex' }}>
          <div style={{ 
            width:'50%', 
            margin: '0 auto',
            padding: '20px',
          }}>
            <h2 style={{ marginBottom: '20px', color:'white' }}>Live Camera Feed</h2>
            <div style={{ 
              position: 'relative',
              backgroundColor: '#000',
              borderRadius: '8px',
              overflow: 'hidden'
            }}>
              <p style={{ 
                marginTop: '10px',
                fontSize: '14px',
                color: '#666'
              }}>
                Stream may take a few seconds to start
              </p>
              <div
                ref={containerRef}
                style={{
                  width:'100%',
                  aspectRatio:'16/9',
                  backgroundColor:'#000'
                }}
              />
            </div>
          </div>
          <div style={{backgroundColor:'white', width:'1px', height:'100%'}} />
          <div style={{ 
            width: '50%',
            padding: '20px',
            color:'white',
            backgroundColor:'black'
          }}>
            <h2 style={{ marginBottom: '20px', color:'white' }}>Controls</h2>
            {socketRef.current && (<div style={{color:'white'}}>Socket id: {socketRef.current.id}</div>)}
            {place?
              place == 1?
                playToken? 
                  <>
                  <div style={{color:'white'}}>Console key: {playToken}</div>
                  <div style={{color:'white', cursor:'pointer', border:'solid 1px white', width:'90px', padding:'3px', textAlign:'center'}} onClick={exitSession}>
                    End Session
                  </div>
                  </>
                :
                <div style={{color:'white', cursor:'pointer', border:'solid 1px white', width:'180px', padding:'3px', textAlign:'center'}} onClick={activateTurn}>you are first in line, Click to activate</div>
              :
              <div>number {place} in queue</div>
            :
              <div style={{color:'white', cursor:'pointer', border:'solid 1px white', width:'90px', padding:'3px', textAlign:'center'}} onClick={enterQueue}>
                Enter Queue
              </div>
            }
          </div>
        </div>
      </div>
  );
}

export default Splash;